import React from 'react';
// import {LockClosedIcon} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
const TitleAndIcon =()=>{
  const {t} = useTranslation()
    return( 
<div>
  <div className="flex items-center space-x-2">
    {/* <LockClosedIcon className="w-4 h-4 text-black md:w-6 md:h-6" /> */}
    <h2 className="mb-4 text-xl font-normal text-black md:text-3xl">
     {t("ControlBoxSection")}
    </h2>
  </div>
  <p className="mb-2 text-sm text-black md:text-lg">
    {t("WelcomeMessage")}
  </p>
</div>

      
    )
}

export default TitleAndIcon;